export default __webpack_public_path__ + "static/media/maintenance_cat_small.33ea2dcb.png";